import apiClient from "./client";
import type {
  CreateAsyncTaskPayload,
  CreateAsyncTaskResponse,
} from "../types/async-task";

export const createAsyncTask = async (
  data: CreateAsyncTaskPayload
): Promise<CreateAsyncTaskResponse> => {
  const requestData =
    data instanceof FormData
      ? data
      : {
          kind: data.kind,
          opt_id: data.opt_id,
        };

  const { data: response } = await apiClient.post<CreateAsyncTaskResponse>(
    "/async_task",
    requestData,
    {
      headers:
        data instanceof FormData
          ? { "Content-Type": "multipart/form-data" }
          : undefined,
    }
  );
  return response;
};
